import { render, staticRenderFns } from "./AddNewItemDropdown.vue?vue&type=template&id=2ee933f2&scoped=true&"
import script from "./AddNewItemDropdown.vue?vue&type=script&lang=js&"
export * from "./AddNewItemDropdown.vue?vue&type=script&lang=js&"
import style0 from "./AddNewItemDropdown.vue?vue&type=style&index=0&id=2ee933f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee933f2",
  null
  
)

export default component.exports